<script setup>
import {useForm} from '@inertiajs/vue3'
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetSecondaryButton from "@/Jetstream/SecondaryButton";

const props = defineProps({
  user: Object,
});

const form = useForm({
  user_id: props.user.id,
});

const sendPasswordResetNotification = () => {
  form.post(
      route('user.password.reset'),
      {
        errorBag: 'sendResetPasswordMail',
        preserveScroll: false,
        onSuccess: () => form.reset(),
        onError: () => {

        },
      }
  );
}
</script>

<template>
  <JetFormSection>
    <template #title>
      {{ $t('Reset password') }}
    </template>

    <template #description>
      <p>{{ $t('Should the customer no longer know their password, a reset email can be sent to the email address assigned to the user.') }}</p>
    </template>

    <template #form>
      <div class="col-span-6 sm:col-span-4">
        <jet-secondary-button type="button" @click.prevent="sendPasswordResetNotification">
          {{ $t('Send password reset email') }}
        </jet-secondary-button>
      </div>

    </template>
  </JetFormSection>
</template>
